import React, { useMemo } from 'react'
import { withTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import Chartist from 'chartist';
import ChartistGraph from 'react-chartist'
import GridContainer from '../../Grid/GridContainer'
import GridItem from '../../Grid/GridItem'

const IntegralVitalSignCharts = (props) => {
  const { temperature, pulse, oxigen, arterialTension, t } = props

  const commonChartOptions = {
    chartPadding: {
      top: 15,
      right: 60,
      bottom: 5,
      left: 60
    },
    fullWidth: true,
    position: 'start',
    lineSmooth: Chartist.Interpolation.cardinal({
      fillHoles: true,
    }),
  }

  const chartsData = useMemo(
    () => [
      {
        customClassNames: 'first',
        label: 'technicalfile.temperature',
        options: { low: 34, high: 45 },
        data: temperature,
        key: 'temperature',
      },
      {
        label: 'technicalfile.pulse',
        options: { low: 45, high: 200 },
        data: pulse,
        key: 'pulse',
      },
      {
        label: 'technicalfile.oxigen',
        options: { low: 50, high: 100 },
        data: oxigen,
        key: 'oxigen',
      },
      {
        label: 'technicalfile.arterialTension',
        options: { low: 40, high: 250 },
        data: arterialTension,
        key: 'arterialTension',
        children: (
          <p className="chart-legend">
            <span className="chart-legend-blue">
              {t('technicalfile.pressureMax')}
            </span>
            <span className="chart-legend-red">
              {t('technicalfile.pressureMin')}
            </span>
          </p>
        ),
      },
    ],
    [temperature, pulse, oxigen, arterialTension, t]
  )

  return (
    <GridContainer className="vitalSignsView">
      {chartsData.map((obj, i) => (
        <GridItem
          xs={12}
          className={`rowItem chartistGraph ${obj.customClassNames}`}
          key={obj.key}
        >
          <h3 className="chart-header headerVitalSigns">{t(obj.label)}</h3>
          <div className="chartistGraphBody">
            <ChartistGraph options={{...commonChartOptions, ...obj.options}} data={obj.data} type="Line" />
            {obj.children}
          </div>
        </GridItem>
      ))}
    </GridContainer>
  )
}

IntegralVitalSignCharts.propTypes = {
  t: PropTypes.func,
  temperature: PropTypes.number,
  pulse: PropTypes.number,
  oxigen: PropTypes.number,
  arterialTension: PropTypes.object,
}

export default withTranslation()(IntegralVitalSignCharts)
